import { render } from "./BlockerManualTable.vue?vue&type=template&id=34aacb52"
import script from "./BlockerManualTable.vue?vue&type=script&lang=js"
export * from "./BlockerManualTable.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__